export default "__VITE_ASSET__CS1xvzoW__"